import { API_URL } from '../constants';
import { InboxBody } from '../types/inbox';
import {
  CommunityRequest,
  ConnectionInvite,
  DataRequest,
  ExternalMemberInviteData,
  Introduction,
  Invite,
  NetworkInviteModel,
  NetworkInviteLinkModel,
  PersonalInvite,
  CrmInviteData,
} from '../types/invites';
import httpService from './httpService';

export function getInvite(linkId: string): Promise<Invite> {
  return httpService.get<Invite>(`/invitation-links/${linkId}`).then(
    ({ data }): Invite => ({
      ...data,
      profilePicture: data.profilePicture && `${API_URL}/${data.profilePicture}`,
    }),
  );
}

export function getConnectionInvite(invitationId: string): Promise<ConnectionInvite> {
  return httpService
    .get<ConnectionInvite>(`/connection-invites/${invitationId}`)
    .then(({ data }): ConnectionInvite => data);
}

export function getExternalMemberInvite(token: string): Promise<ExternalMemberInviteData> {
  return httpService
    .get<ExternalMemberInviteData>(`/networks/dashboards/0/external-members/invite?token=${token}`)
    .then(({ data }): ExternalMemberInviteData => data);
}

export function getNetworkInvite(invitationId: string): Promise<NetworkInviteModel | NetworkInviteLinkModel> {
  const isNumeric = /^\d+$/.test(invitationId);
  if (isNumeric) {
    return httpService
      .get<NetworkInviteModel>(`/networks/invites/${invitationId}`)
      .then(({ data }): NetworkInviteModel => data);
  }

  return httpService
    .get<NetworkInviteLinkModel>(`/networks/invite-links/${invitationId}`)
    .then(({ data }): NetworkInviteLinkModel => data);
}

export function getCrmUserInvite(token: string): Promise<CrmInviteData> {
  return httpService
    .get<CrmInviteData>(`/networks/businesses/0/integrations/invite?token=${token}`)
    .then(({ data }) => data);
}

export function requestExternalMemberInviteWithDifferentEmail(dashboardId: number, token: string): Promise<void> {
  return httpService
    .post(`/networks/dashboards/${dashboardId}/external-members/invites/different-email?token=${token}`)
    .then(() => {});
}

export function getPersonalInvite(token: string): Promise<PersonalInvite> {
  return httpService.get<PersonalInvite>(`/personal-invites/${token}`).then(({ data }): PersonalInvite => data);
}

export function getDataRequest(token: string): Promise<DataRequest> {
  return httpService.get<DataRequest>(`/data-requests/?token=${token}`).then(({ data }): DataRequest => data);
}

export function getIntroductions(): Promise<Introduction[]> {
  return httpService.get<Introduction[]>('/introductions/@me').then(({ data }): Introduction[] => data);
}

export function getCommunityRequest(token: string): Promise<CommunityRequest> {
  return httpService
    .get<CommunityRequest>(`/networks/communities/connection-requests/via-token/${token}`)
    .then(({ data }): CommunityRequest => data);
}

export function getRequestsAndInvites(): Promise<InboxBody> {
  return httpService.get<InboxBody>('/notifications/inbox').then(({ data }): InboxBody => data);
}
